import React, {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { Location } from 'history';

type StringArray = string[] | [];

interface RoutesHistory {
    history: StringArray;
}

const RoutesHistoryContext = createContext<RoutesHistory | undefined>(
    undefined
);

export const useRoutesHistory = () => {
    return useContext(RoutesHistoryContext);
};

interface RoutesHistoryProviderProps {
    children: ReactNode;
}

export const RoutesHistoryProvider: React.FC<RoutesHistoryProviderProps> = ({
    children,
}) => {
    const [history, setHistory] = useState<StringArray>([]);
    const routerHistory = useHistory();

    useEffect(() => {
        return routerHistory.listen((location: Location) => {
            setHistory((prevHistory) => [...prevHistory, location.pathname]);
        });
    }, [routerHistory]);

    return (
        <RoutesHistoryContext.Provider
            value={{
                history,
            }}
        >
            {children}
        </RoutesHistoryContext.Provider>
    );
};
